import React, { createContext, useContext, useState, useEffect } from "react";
import paginationSizeStorage from "./context";

const { fetchPaginationSize, storePaginationSize } = paginationSizeStorage;

const TablePaginationContext = createContext();

const TablePaginationProvider = ({ children }) => {
  const [tablePaginationSize, setTablePaginationSize] = useState(parseInt(fetchPaginationSize()));

  const handleSetPaginationSize = newTablePaginationSize => {
    setTablePaginationSize(newTablePaginationSize);
  };

  useEffect(
    () => {
      storePaginationSize(tablePaginationSize);
    },
    [tablePaginationSize],
  );

  return (
    <TablePaginationContext.Provider value={{ tablePaginationSize, handleSetPaginationSize }}>
      {children}
    </TablePaginationContext.Provider>
  );
};

const useTablePaginationContext = () => {
  const context = useContext(TablePaginationContext);
  if (context === undefined) {
    throw new Error("useTablePaginationContext must be used within a TablePaginationProvider");
  }
  return context;
};

export { TablePaginationProvider, useTablePaginationContext };
